import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullScreen = false, size = 'medium' }) => {
    return (
        <div className={`loading-spinner-container ${fullScreen ? 'fullscreen' : ''}`}>
            <div className={`loading-spinner ${size}`}></div>
        </div>
    );
};

export default LoadingSpinner;